import { maxios } from "src/maxios";

import {
  LoginRequestDto,
  LoginResponseDto,
  PasswordCheckRequestDto,
  PasswordCheckResponseDto,
  ResetPasswordRequestDto,
} from "./auth.dto";

/**
 * 로그인
 */
const login = async (request: LoginRequestDto) => {
  const { data } = await maxios.post<LoginResponseDto>("/v2/login", request);
  return data;
};

/**
 * 토큰 재발급 (Refresh Token으로 Access Token 갱신)
 */
const reissue = async (refreshToken: string) => {
  const { data } = await maxios.post<LoginResponseDto>("/v2/reissue", {
    refreshToken,
  });
  return data;
};

/**
 * 로그아웃 (서버 측 토큰 무효화)
 */
const logout = async (refreshToken: string) => {
  await maxios.post("/v2/logout", { refreshToken });
};

/**
 * 레거시 토큰을 JWT로 변환
 */
const migrateLegacyToken = async (legacyToken: string) => {
  const { data } = await maxios.post<LoginResponseDto>(
    "/v2/x-auth-token-to-jwt",
    {},
    {
      headers: {
        "x-auth-token": legacyToken,
      },
    }
  );
  return data;
};

/**
 * 비밀번호 재설정 요청
 */
const resetPassword = async (request: ResetPasswordRequestDto) => {
  await maxios.post("/password/reset-token", request);
};

/**
 * 비밀번호 확인
 */
const checkPassword = async (request: PasswordCheckRequestDto) => {
  const { data } = await maxios.post<PasswordCheckResponseDto>(
    "/v2/password-check",
    request
  );
  return data;
};

/**
 * 인증 관련 API
 */
export const AuthApi = {
  login,
  reissue,
  logout,
  migrateLegacyToken,
  resetPassword,
  checkPassword,
};
